/** Catalogue row-open through the shell-scoped inspector. */
import { inject, Injector } from '@angular/core';
import { ActivityEntityName, ServicePlanTemplate } from '@jms/model';
import { EntityInspectors } from '@workbuddy/ui/v2/blocks/entity.inspector';

export async function navigateToServicePlanTemplateManage(item: ServicePlanTemplate): Promise<void> {

  if (!item?._id) return;
  const injector = inject(Injector);

  await injector.get(EntityInspectors).open({
    operation: 'edit',
    entity: ActivityEntityName.ServicePlanTemplate,
    id: item._id,
  });
}
